var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isConnect && _vm.hospitalConnection)?_c('div',{staticClass:"hospital-connection-tag"},[_c('div',[_vm._v(" "+_vm._s(_vm.text)+" "),_c('div',{staticClass:"text-style-1"},[_vm._v(_vm._s(_vm.hospitalConnection.hospital.name))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }